export const locale = {
  GLOBAL: {
    Title: "簡訊樂園",
    PostalCode: "郵遞區號",
    postalCodes: "郵遞區號",
    selectedPostalCodes: "已選郵遞區號",
    MciNumberCount: "伊朗移動（MCI）號碼數量",
    MtuNumberCount: "伊朗移動（MTN/Irancell）號碼數量",
    TotalCount: "總數",
    Coefficient: "係數",
    Back: "返回",
  },
  ERRORS: {
    PhoneIsNotValid: "輸入的手機號碼格式不正確：範例 09101234567",
    InvalidNumber: "輸入的數量不正確",
    NoSelectedLineNumber: "請選擇發送線路。",
    EmptyText: "請輸入簡訊內容。",
    UnknownError: "未知錯誤",
    TryAgain: "請稍後再試。",
    NoAccountCharge: "餘額不足",
    NoAccess: "您沒有權限。",
    PleasebyeAPlane: "請先購買一個套餐。",
    PleaseChargeYourAccount: "請為您的帳戶充值。",
    AccessDenied: "存取被拒絕。",
    AccessDeniedDescription: "如需更多資訊，請聯繫客服",
    Error: "錯誤",
    InvalidText: "簡訊內容無效",
    InvalidTextContainsLink: "只有服務類線路可以發送包含連結的內容。",
  },
  INFOS: {
    SuccessSentSms: "簡訊發送成功",
    SmsRequestInQueue: "您的簡訊將在管理員審核後發送",
    SendData: "發送資訊",
    CheckData: "請閱讀並確認以下資訊。",
  },
  TOBE: { to: "至 ", from: "從 " },
  FORMS: {
    DestinationPhone: "接收手機號碼",
    TestDestinationPhone: "測試手機號碼",
    SourceNumber: "發送號碼",
    Text: "簡訊內容",
    CharCount: "字元數",
    FarsiCharCount: "波斯文字元數",
    EnglishCharCount: "英文字元數",
    Send: "發送",
    SendTime: "發送時間",
    SendTest: "發送測試",
    SendToTestNumber: "發送到測試號碼",
    SmsCount: "簡訊條數",
    SmsLang: "簡訊語言",
    Add: "新增",
    FromFile: "從檔案新增",
    TestNumber: "測試號碼",
    Test: "測試",
    ServiceRelated: "服務類",
    Price: "價格",
    NumbersCount: "號碼數量",
    NumbersCountToSend: "將要發送簡訊的號碼數量",
    Search: "搜尋",
    Title: "標題",
    RequestTime: "請求時間",
    RequestInformation: "請求資訊",
    CreateNewPhoneBook: "建立新電話簿",
  },
  BUTTONS: {
    OK: "確定",
    AccountCharge: "帳戶充值",
    Reports: "報表",
    RemoveAll: "全部刪除",
    BuyAPlane: "購買套餐",
    Accept: "確認",
    Reject: "拒絕",
    Yes: "是",
    No: "否",
    Create: "建立",
    New: "新增",
    Save: "儲存",
    Delete: "刪除",
    More: "更多",
    TryAgain: "重試",
    Close: "關閉",
    RollBack: {
      back: "返回上一個使用者",
      goToMainUser: "返回主使用者",
      CurrentUser: "目前使用者",
    },
  },
  DIALOGS: {
    Waiting: "請稍候",
    RejectItQuestion: "是否拒絕？",
    AcceptItQuestion: "是否確認？",
    Rejected: "已拒絕",
    Accepted: "已確認",
    Error: "錯誤",
  },
  CONFIRM: {
    Delete: "您確定要刪除嗎？",
    DeleteA: "您確定要刪除 {a} 嗎？",
    DeleteALL: "您確定要全部刪除嗎？",
  },
  LANGUAGE: {
    English: "英文",
    Persian: "波斯語",
  },
  language: {
    selectAll: "全選",
    lang: {
      fa: "波斯語",
      ar: "阿拉伯語",
      ar_ae: "阿拉伯語 (阿聯酋)",
      ar_iq: "阿拉伯語 (伊拉克)",
      en_US: "英語 (美國)",
      en_GB: "英語 (英國)",
      de: "德語",
      fr: "法語",
      zh_CN: "簡體中文",
      zh_TW: "繁體中文",
      tr: "土耳其語",
      ru: "俄語",
      hy: "亞美尼亞語",
    },
    only_manual_now: "目前僅支援手動翻譯",
    ai_coming_soon: "AI 翻譯即將上線",
    got_it: "知道了",
    origin_language: "來源語言",
    target_languages: "目標語言",
    remove_all: "移除所有語言",
    translation_method: "選擇翻譯方式",
    manual_translation: "手動翻譯",
    ai_translation: "AI 翻譯",
    coming_soon: "即將推出",
    source_language_updated: "來源語言已更新",
    error_changing_source_language: "更改來源語言時出錯",
    source_language_created: "已建立新來源語言",
    languages_saved: "新語言已儲存",
    error_saving_languages: "儲存語言時出錯",
    error_loading_language: "載入語言時出錯",
    languages_removed: "已移除的語言",
    new_languages_to_save: "待儲存的新語言",
    saved: "已儲存",
    management_langs: "語言管理",
    add_langs: "新增語言",
    change_language: "更改語言",
    visit_card: "名片",
    translate_to: "翻譯為",
    main_language: "主要語言",
    no_languages_available: "無可用語言",
    return_to_default: "返回預設語言",
    translate: "翻譯",
    changes_pending: "等待應用更改",
    apply_changes: "套用變更",
    cancel_changes: "取消",
  },

  LISTS: {
    NoData: "暫無資料",
    NoDataFound: "找不到資料",
    NoDataFoundFor: "找不到關於 {a} 的資料",
    NoPhoneNumber: "找不到手機號碼",
    NoPostalCode: "找不到郵遞區號",
    AddANumber: "請新增一個號碼",
    City: "城市",
    AddedBefore: "已新增過",
  },
  PAGES: {
    SendSms: "發送簡訊",
    MapSms: "地圖發送",
    PhoneBook: "電話簿",
  },
  MONETARY: {
    Rial: "里亞爾",
  },
  HINTS: {
    SendMessageTitle:
      "標題為您自訂的名稱，可使用之前發送過的簡訊標題，內容會自動填入「簡訊內容」欄位。標題不會發送給收件人，僅用於報表與簡訊建議功能。",
    SendMessageTime:
      "發送時間是指您的簡訊進入發送佇列的時間。請注意：若管理員未通過審核，簡訊將不會發送。",
    CreatePhoneBook: "發送簡訊時，可透過此名稱快速選擇已儲存的電話簿。",
  },
  TOASTS: {
    SuccessCreate: "建立成功",
    FailedCreated: "建立失敗",
    SuccessDelete: "刪除成功",
    FailedDelete: "刪除失敗",
    SuccessEdit: "編輯成功",
    FailedEdit: "編輯失敗",
    AddedSuccess: "新增成功",
    AddedFailed: "新增失敗",
  },
  WALLET: {
    CustomCharge: "自訂金額",
    GateWay: "支付閘道",
    Price: "金額",
    Details: [
      "將額外收取9%的稅費。",
      "請仔細填寫充值金額，充值成功後金額不可退還。",
    ],
    noGateWay: "您尚未設定支付閘道。",
    PriceNotInRange: "輸入金額必須在 {min} 里亞爾至 {max} 里亞爾之間。",
    Pay: "付款",
    ErrorOnRedirectToGateWay: "跳轉至支付閘道時發生錯誤",
    ChargeWalletButtonDescription: "點擊 + 按鈕為您的帳戶充值",
  },
  login: {
    phoneField: {
      placeholderIran: "以9開頭（例如：+98 912 345 6789）",
      placeholderDefault: "請輸入您的手機號碼",
      maxDigitsError: "最多允許 {count} 位數字！",
      iranMustStartWith9: "伊朗手機號碼必須以9開頭（如912…）",
    },
    signup_button: "我要註冊！",
    forget_password_title: "忘記密碼",
    register_title: "免費註冊",
    login_title: "登入",
    back: "返回",
    username_label: "手機號碼／使用者名稱",
    otp_resend_button: "重新發送驗證碼",
    password_label: "密碼",
    password_hint: "至少8個字元",
    name_label: "姓名",
    name_rule: "至少3個字元",
    lastname_label: "姓氏",
    phone_label: "手機號碼",
    nid_label: "國民身分證號",
    parent_phone_label: "推薦人手機號碼（選填）",
    terms_and_conditions_message: "註冊即表示您同意廣告終端的所有規則與條款。",
    terms_and_conditions_link: "規則與條款",
    close: "關閉",
    forgot_password_link: "忘記密碼？",
    change_password: "變更密碼",
    register_button: "註冊",
    login_button: "登入",
    login_with_google: "使用Google登入",
    login_with_sms: "簡訊驗證碼登入",
    login_with_password: "密碼登入",
    already_registered: "已經註冊？",
    login_here: "立即登入",
    no_account: "還沒有帳號？",
    signup_now: "立即註冊！",
    more_info: "更多資訊",
    text_login: "登入",
    text_register: "註冊",
    required_field: "此為必填欄位。",
    min_8_char: "內容少於8個字元",
    required: "此欄位必填",
    min_3_char: "至少3個字元",
    max_50_char: "最多50個字元",
    no_internet: "您未連線到網路",
    no_phone_entered: "您尚未輸入手機號碼",
    otp_sent_successfully: "驗證碼已成功發送。",
    please_register_first: "請先註冊！",
    wait_3_min: "請等待3分鐘後再次請求。",
    login_successful: "登入成功",
    internet_connection_error: "網路連線異常！",
    agree_to_terms_error: "您尚未同意服務條款！",
    otp_sent_successfully_register: "驗證碼發送成功。",
    error: "錯誤",
    registration_nid_required_notice:
      "為了提供高安全性服務並防止釣魚詐騙與系統濫用，在廣告終端註冊時必須填寫國民身分證號。",
  },
  home: {
    title: "首頁",
    selectSystem: "選擇系統",
    yourPoints: "您的積分",
    discountCodes: "優惠碼",
    all: "全部",
    discounts: "優惠",
    systemGuide: "系統指南",
    yourPointsDynamic: "您的積分：{points}",
    confirm: "確認",
    copy: "複製",
  },
  badges: {
    free: "免費",
    preRegister: "預註冊",
    comingSoon: "即將推出",
    testVersion: "測試版",
  },
  services: {
    qrLand: {
      title: "QR樂園系統",
      description: "建立動態二維碼",
      property: {
        0: "審查並選擇廣告類型與位置",
        1: "審查並選擇影院廣告類型",
        2: "無需支付額外佣金與費用",
        3: "統一管理所有影院廣告",
      },
    },
    payamak: {
      title: "簡訊樂園系統",
      description: "批量發送廣告簡訊",
      property: {
        0: "批量發送簡訊",
        1: "擁有最新號碼庫",
        2: "向客戶俱樂部發送簡訊",
        3: "可連接所有網站與軟體",
      },
    },
    robot: {
      title: "機器人樂園系統",
      description: "同時管理所有號碼、廣告與面板",
      property: {
        0: "批量與大量發布廣告",
        1: "定時、漸進式與智能廣告管理",
        2: "無限租用與新增號碼用於發布廣告",
        3: "同時註冊與管理所有廣告",
      },
    },
    infoLand: {
      title: "資訊樂園",
      description: "超過 2500 個最新行業資訊資料庫",
      property: {
        0: "包含所有行業完整資訊",
        1: "按城市與省份分類",
        2: "全國所有行業資料庫",
        3: "可查看所有資料庫樣本",
      },
    },
    graphic: {
      title: "圖形樂園系統",
      description: "從 0 到 100 的平面設計與影片製作",
      property: {
        0: "設計 LOGO 與企業識別系統",
        1: "所有印刷與包裝服務",
        2: "設計型錄、手冊、包裝盒",
        3: "設計並印刷各種尺寸橫幅看板",
      },
    },
    bestWebLand: {
      title: "最佳網站樂園系統",
      description: "網站設計、維護與 SEO 優化",
      property: {
        0: "內容 SEO",
        1: "站外 SEO（Off-page）",
        2: "技術 SEO（Technical）",
        3: "站內 SEO（On-page）",
      },
    },
    onlineShop: {
      title: "線上建站系統",
      description: "只需幾次點擊即可進入數位世界",
      badge: "分銷合作",
      property: {
        0: "內容 SEO",
        1: "站外 SEO（Off-page）",
        2: "技術 SEO（Technical）",
        3: "站內 SEO（On-page）",
      },
    },
    social: {
      title: "社群媒體廣告",
      description: "精選最優質的粉絲頁與頻道投放",
      property: {
        0: "審核所有高流量粉絲頁",
        1: "統一管理所有廣告",
        2: "無需支付額外佣金",
        3: "線上下單喜愛的粉絲頁廣告",
      },
    },
    billboard: {
      title: "線上看板租賃",
      description: "無仲介，精準挑選看板位置",
      property: {
        0: "審核看板位置與類型",
        1: "管理所有線上看板",
        2: "與看板擁有者直接聯繫",
        3: "無需支付佣金與額外費用",
      },
    },
    internationalMedia: {
      title: "國家級媒體廣告",
      description: "在電視與廣播投放廣告",
      property: {
        0: "審核廣告播出時段",
        1: "選擇電視廣告類型",
        2: "選擇廣播廣告類型",
        3: "選擇節目內插播廣告",
      },
    },
    transport: {
      title: "交通運輸工具廣告",
      description: "機場、火車站、公車與地鐵",
      property: {
        0: "審核廣告類型與位置",
        1: "審核地鐵廣告類型",
        2: "無需支付額外佣金",
        3: "統一管理所有地鐵廣告",
      },
    },
    cinema: {
      title: "影院與影片平台廣告",
      description: "在電影院與影片分享網站投放廣告",
      property: {
        0: "審核廣告類型與位置",
        1: "審核影院廣告類型",
        2: "無需支付額外佣金",
        3: "統一管理所有影院廣告",
      },
    },
    estate: {
      title: "線上房地產系統",
      description: "管理房源、顧問與客戶",
      property: {
        0: "審核並選擇廣告類型與位置",
        1: "審核並選擇影院廣告類型",
        2: "無需支付額外佣金與費用",
        3: "統一管理所有影院廣告",
      },
    },
    AIGeneration: {
      title: "人工智慧系統",
      description: "生成圖片、聊天機器人",
    },
    ShortLink: {
      title: "短網址系統",
      description: "建立短網址",
    },
    customer: {
      title: "線上客戶管理系統",
      description: "管理、支援並培養忠誠客戶",
      property: {
        0: "審核並選擇廣告類型與位置",
        1: "審核並選擇影院廣告類型",
        2: "無需支付額外佣金與費用",
        3: "統一管理所有影院廣告",
      },
    },
    internetBroadcasting: {
      title: "網路廣告投放與管理",
      description: "Google Ads、點擊付費廣告、軟文推廣",
      property: {
        0: "審核並選擇廣告類型與位置",
        1: "審核並選擇影院廣告類型",
        2: "無需支付額外佣金與費用",
        3: "統一管理所有影院廣告",
      },
    },
    emailMarketing: {
      title: "電子郵件行銷系統",
      description: "向全國所有行業發送廣告郵件",
      property: {
        0: "審核並選擇廣告類型與位置",
        1: "審核並選擇影院廣告類型",
        2: "無需支付額外佣金與費用",
        3: "統一管理所有影院廣告",
      },
    },
    adsOnStudium: {
      title: "體育場館與展覽廣告",
      description: "讓您的品牌出現在最大型活動中心",
      property: {
        0: "審核並選擇廣告類型與位置",
        1: "審核並選擇影院廣告類型",
        2: "無需支付額外佣金與費用",
        3: "統一管理所有影院廣告",
      },
    },
    bidOnline: {
      title: "綜合線上拍賣系統",
      description: "線上舉辦拍賣或參與競標",
      property: {
        0: "審核並選擇廣告類型與位置",
        1: "審核並選擇影院廣告類型",
        2: "無需支付額外佣金與費用",
        3: "統一管理所有影院廣告",
      },
    },
    onlineTools: {
      title: "線上商業工具系統",
      description: "各種業務所需的輔助工具",
      property: {
        0: "審核並選擇廣告類型與位置",
        1: "審核並選擇影院廣告類型",
        2: "無需支付額外佣金與費用",
        3: "統一管理所有影院廣告",
      },
    },
    onlineLearn: {
      title: "職業線上教育系統",
      description: "精準挑選行業培訓課程",
      property: {
        0: "審核並選擇廣告類型與位置",
        1: "審核並選擇影院廣告類型",
        2: "無需支付額外佣金與費用",
        3: "統一管理所有影院廣告",
      },
    },
    cloud: {
      title: "主機與域名購買",
      description: "購買主機、域名與伺服器",
      property: {
        0: "審核並選擇廣告類型與位置",
        1: "審核並選擇影院廣告類型",
        2: "無需支付額外佣金與費用",
        3: "統一管理所有影院廣告",
      },
    },
    QrlandShop: {
  title: "網路商店管理",
  description: "整合管理商品、線上市集與智慧定價",
  property: {
    0: "全面監控與管理商品",
    1: "商品規格管理",
    2: "監控與管理線上市集",
    3: "智慧定價策略",
  },
},

  },

  "planning.title": "行程規劃",
  "tabs.reminder": "提醒事項",
  "tabs.notes": "備忘錄",
  "tabs.calendar": "日曆",
  "notes.creationDate": "建立日期",
  "common.save": "儲存",
  "common.cancel": "取消",
  "actions.quickActions": "快速動作",
  "notes.writeMessage": "撰寫訊息",
  "notes.titlePlaceholder": "備忘錄標題",
  "notes.addNote": "新增備忘錄",
  "notes.updatedSuccess": "備忘錄已成功更新。",
  "notes.addedSuccess": "備忘錄已成功新增。",
  "common.deletedSuccess": "已成功刪除",
  "common.confirmDelete": "您確定要刪除嗎？",
  "news.title": "網站最新消息",
  "news.noNews": "網站目前沒有任何消息。",
  "news.view": "查看",
  "remember.add": "建立提醒",
  "remember.update": "更新提醒",
  "remember.titleLabel": "標題",
  "remember.dateLabel": "提醒日期",
  "remember.confirmDelete": "您確定要刪除嗎？",
  "remember.deleteSuccess": "提醒已成功刪除。",
  "remember.createSuccess": "已成功建立新提醒。",
  "remember.updateSuccess": "提醒已更新。",
  "points.receivedAwards": "已獲得獎勵",
  "points.pointsHistory": "積分紀錄",
  "points.points": "積分",
  "points.discountTitle": "機器人樂園折扣",
  "points.discountText": "每 500 積分",
  events: {
    title: "事件",
    addEvent: "新增事件",
    calendar: "基礎日曆",
    close: "關閉",
    save: "儲存",
    update: "更新",
    confirmDelete: "您確定要刪除嗎？",
    successAdd: "已成功新增。",
    successDelete: "事件已成功刪除。",
    successUpdate: "更新成功。",
    titleLabel: "標題",
    descriptionLabel: "說明",
    colorLabel: "顏色",
    removeAfterDrop: "拖曳完成後移除",
    createEvent: "建立事件",
  },
  copySuccess: "已成功複製。",
  copyTextTitle: "複製文字",
  copiedTextTitle: "已複製",
  ribbon: {
    new: "最新",
  },
  coupons: [
    {
      text: "此優惠券有效期 3 週",
      title: "獨特文案 20% 折扣",
    },
    {
      text: "此優惠券有效期 2 週",
      title: "網站設計 5% 折扣",
    },
    {
      text: "此優惠券僅限使用一次",
      title: "粉絲頁管理 10% 折扣",
    },
    {
      text: "此優惠券已永久為您啟用",
      title: "平面設計 5% 折扣",
    },
    {
      text: "此優惠券僅限使用一次",
      title: "印刷 2% 折扣",
    },
  ],
  userLinks: {
    profile: {
      title: "總覽",
      invitation: { title: "邀請好友" },
      info: { title: "個人資料" },
      edit: { title: "完善個人檔案" },
      changePass: { title: "變更密碼" },
    },
  },
  profileLinks: {
    orders: "訂單",
    addresses: "地址",
  },
  customPage: {
    overview: "總覽",
    personalInfo: "個人資料",
    changePassword: "變更密碼",
    completeProfile: "完善個人檔案",
    email: "電子郵件",
    balance: "餘額",
    phone: "手機號碼",
    rial: "里亞爾",
  },
  widget12: {
    inviteFriends: "邀請好友",
    viewInvitedUsers: "查看您推薦的使用者清單",
    yourInviteCode: "您的邀請碼",
    createNewUser: "建立新使用者",
    copyText: "複製",
    userCreatedSuccess: "新使用者建立成功",
    notCreated: "尚未建立",
  },
  userInfo: {
    userInformation: "使用者資訊",
    profilePicture: "個人頭像",
    allowedFileTypes: "允許的檔案類型：png、jpg、jpeg。",
    profilePictureSize: "頭像必須為正方形（例如：480 × 480）。",
    firstName: "姓名",
    lastName: "姓氏",
    username: "使用者名稱",
    phone: "聯絡電話",
    email: "電子郵件",
    receiveSMS: "接收簡訊",
    smsCostNote: "啟用此選項後，簡訊發送費用將從您的帳戶扣除。",
    saveChanges: "儲存變更",
    profileUpdated: "您的個人檔案已成功更新。",
  },
  emailSettings: {
    completeProfile: "完善個人檔案",
    completeProfileDesc: "填寫個人或公司資訊",
    cancel: "取消",
    update: "更新",
    save: "儲存",
    selectPersonType: "請選擇人員類型？",
    realPerson: "自然人",
    legalPerson: "法人",
    phone: "手機號碼",
    landline: "市內電話",
    fatherName: "父親姓名",
    nationalCode: "國民身分證字號",
    idNumber: "身分證字號",
    birthday: "出生日期",
    placeOfBirth: "出生地",
    postalCode: "郵遞區號",
    email: "電子郵件",
    introduction: "您是如何認識我們的",
    nationalCodePic: "國民身分證照片",
    plaque: "門牌號碼",
    address: "完整地址",
    companyName: "公司／店鋪名稱",
    registrationNumber: "公司登記號碼",
    economicCode: "經濟代碼",
    organizationIdentity: "組織國民身分證號",
    companyType: "公司類型",
    activity: "經營領域",
    registrationAd: "公司登記公告圖片",
    lastPublishedAd: "最近一次官方公告圖片",
    statute: "公司章程圖片",
    agentLetterPic: "代理人介紹信圖片",
    successMessage: "儲存成功",
    errorSelectType: "請選擇一項。",
    rules: {
      companyName: "公司／店鋪名稱為必填欄位。",
      registrationNumber: "公司登記號碼為必填欄位。",
      economicCode: "經濟代碼為必填欄位。",
      organizationIdentity: "組織國民身分證號為必填欄位。",
      registrationAd: "公司登記公告圖片為必填欄位。",
      lastPublishedAd: "最近一次官方公告圖片為必填欄位。",
      telephone: "市內電話為必填欄位。",
      fatherName: "父親姓名為必填欄位。",
      nationalCode: "國民身分證字號為必填欄位。",
      birthday: "出生日期為必填欄位。",
      idNumber: "身分證字號為必填欄位。",
      placeOfBirth: "出生地為必填欄位。",
      postalCode: "郵遞區號為必填欄位。",
      nationalCodePic: "國民身分證照片為必填欄位。",
      address: "完整地址為必填欄位。",
      plaque: "門牌號碼為必填欄位。",
    },
    companyTypes: {
      governmental: "國營",
      private: "民營",
      commonStock: "公開發行公司",
      specialStock: "非公開發行公司",
    },
  },
  changePassword: {
    title: "變更密碼",
    description: "變更您的帳戶密碼",
    cancel: "取消",
    update: "更新",
    passwordInstructions: {
      forgotPassword: "若您尚未設定過密碼，可點擊「忘記密碼」進行重設。",
      passwordRequirements:
        "密碼必須至少 8 個字元，包含數字、大小寫英文字母與符號。",
      passwordPrivacy: "請勿將密碼告知他人。",
      keyboardLanguage: "設定密碼時請確認鍵盤為英文輸入法。",
    },
    currentPassword: "目前密碼",
    newPassword: "新密碼",
    confirmNewPassword: "確認新密碼",
    addOrForgotPassword: "新增或忘記密碼",
    changePasswordWithCode: "使用手機號碼變更密碼",
    close: "關閉",
    change: "變更",
    enterCode: "請輸入驗證碼",
    successMessage: "密碼已成功更新",
    invalidCode: "驗證碼錯誤。",
    tooManyAttempts: "嘗試次數過多！",
    rules: {
      required: "此欄位為必填。",
      min: "密碼不得少於 8 個字元",
      equal: "兩次輸入的密碼不一致",
      number: "請輸入正確的手機號碼",
    },
  },
  router: {
    dashboard: "儀表板",
    contacts: "客戶俱樂部",
    editContact: "編輯客戶",
    createContact: "新增客戶",
    customers: "客戶清單",
    contactList: "通訊錄助手",
    messages: "訊息",
    messageCategories: "訊息分類",
    oldTransactions: "歷史交易",
    yourTransactions: "您的交易",
    buyPanel: "購買面板",
    permissions: "權限",
    createPermission: "新增權限",
    invitations: "我的邀請名單",
    editUser: "編輯使用者",
    userInformation: "查看使用者資訊",
    walletEdit: "編輯使用者錢包資訊",
    userHistory: "使用者歷史",
    userNotificationsHistory: "使用者通知紀錄",
    notifications: "通知",
    createNotification: "建立通知",
    editNotification: "編輯通知",
    adminNotifications: "管理員通知",
    yourNotifications: "您的通知",
    adminNotificationsList: "管理員通知清單",
    tickets: "客服單",
    createTicket: "提交新客服單",
    editTicket: "編輯客服單",
    departments: "部門",
    createDepartment: "新增部門",
    editDepartment: "編輯部門",
    adminTickets: "客服單管理",
    discounts: "折扣",
    createDiscount: "新增折扣",
    editDiscount: "編輯折扣",
    workReports: "工作報告",
    createWorkReport: "建立工作報告",
    callMonitoring: "通話監控",
    adminWorkReports: "工作報告管理",
    editWorkReport: "查看並編輯工作報告",
    packProperties: "套餐特性",
    createPackProperty: "新增套餐特性",
    editPackProperty: "編輯套餐特性",
    panels: "面板",
    createPanel: "建立面板",
    editPanel: "編輯面板",
    transferRequests: "提領申請",
    editTransferRequest: "編輯提領申請",
    tariffs: "資費",
    createTariff: "新增資費",
    editTariff: "編輯資費",
    requests: "請求",
    viewUser: "查看使用者",
    manageTransactions: "交易管理",
    viewTransaction: "查看交易",
    manageConfigs: "設定管理",
    rbLandConfigs: "機器人樂園設定管理",
    editConfig: "編輯設定",
    manageUsers: "使用者管理",
    categories: "分類",
    createCategory: "新增分類",
    editCategory: "編輯分類",
    content: "內容",
    createContent: "新增內容",
    editContent: "編輯內容",
    addUserGuide: "新增使用者指南",
    editUserGuide: "編輯使用者指南",
    roles: "角色",
    editRole: "編輯角色",
    createRole: "新增角色",
    permissionTitle: "權限",
    paymentGateways: "支付閘道",
    editPaymentGateway: "編輯支付閘道",
    campaigns: "行銷活動",
    createCampaign: "建立活動",
    editCampaign: "編輯活動資訊",
    adminCustomers: "客戶",
    createCustomer: "新增客戶",
    editCustomerInfo: "編輯客戶資訊",
    referrerCustomers: "推薦客戶",
    customerHistory: "客戶歷史",
    userProfile: "使用者個人檔案",
    editProfile: "編輯個人檔案",
    inviteFriends: "邀請好友",
    personalInfo: "個人資料",
    editPersonalInfo: "編輯資料",
    changePassword: "變更密碼",
    newWallet: "新錢包",
  },
  profileView: {
    email: "電子郵件",
    balance: "餘額",
    personType: "人員類型",
    currency: "里亞爾",
    unknown: "----",
  },
  panelInfoProfile: {
    panelTitle: "您擁有 {title} 面板（{days} 天有效期）",
    buyOrRenew: "點擊下方按鈕購買或續費您的面板。",
    buyPanel: "購買面板",
    percentage: "%",
  },
  profileSetting: {
    cardTitle: "個人檔案設定",
    changePasswordTitle: "變更登入密碼",
    changePasswordSubtitle: "變更您的帳戶登入密碼。",
    alertMessage: "若您尚未設定密碼，請勾選「設定登入密碼」選項。",
    currentPasswordLabel: "目前密碼",
    setPasswordLabel: "設定密碼",
    addPassword: "新增密碼",
    newPasswordLabel: "新密碼",
    repeatPasswordLabel: "再次輸入密碼",
    saveChanges: "儲存變更",
    currentPasswordPlaceholder: "目前密碼",
    newPasswordPlaceholder: "新密碼",
    repeatPasswordPlaceholder: "再次輸入密碼",
  },
  profileOrders: {
    cardTitle: "訂單",
    openOrders: "進行中的訂單 ({count})",
    closedOrders: "已完成的訂單 ({count})",
    noOrders: "您目前還沒有訂單",
  },
  personalInformation: {
    cardTitle: "個人帳戶資訊",
    cardSubtitle: "更新您的個人資料。",
    cancel: "取消",
    update: "更新",
    yourInfo: "您的資訊",
    profilePicture: "個人頭像",
    allowedFileTypes: "允許的檔案類型：png、jpg、jpeg。",
    pictureSize: "頭像必須為正方形（例如：480 × 480）。",
    name: "姓名",
    lastName: "姓氏",
    username: "使用者名稱",
    receiveSMS: "接收簡訊",
    smsCostNote: "啟用此選項後，簡訊發送費用將從您的帳戶扣除。",
    phoneNumber: "手機號碼",
    phonePlaceholder: "手機號碼",
    email: "電子郵件",
    emailPlaceholder: "電子郵件",
    emailPrivacy: "我們絕不會與他人分享您的電子郵件。",
    successMessage: "您的個人檔案已成功更新。",
  },
  userInfoForm: {
    companyName: "公司／店鋪名稱",
    registrationNumber: "公司登記號碼",
    economicCode: "經濟代碼",
    organizationIdentity: "組織國民身分證號",
    companyType: "公司類型",
    activity: "經營領域",
    registrationAd: "公司登記公告圖片",
    lastPublishedAd: "最近一次官方公告圖片",
    statute: "公司章程圖片",
    argentLetterPic: "代理人介紹信圖片",
    phone: "手機號碼",
    telephone: "市內電話",
    fatherName: "父親姓名",
    nationalCode: "國民身分證字號",
    id: "身分證字號",
    birthday: "出生日期",
    placeBirthday: "出生地",
    postalCode: "郵遞區號",
    email: "電子郵件",
    introduction: "您是如何認識我們的",
    nationalCodePic: "國民身分證照片",
    plaque: "門牌號碼",
    address: "完整地址",
    companyTypes: {
      governmental: "國營",
      private: "民營",
      common_stock: "公開發行公司",
      special_stock: "非公開發行公司",
    },
    rules: {
      companyName: "公司／店鋪名稱為必填欄位。",
      registration_number: "公司登記號碼為必填欄位。",
      economic_code: "經濟代碼為必填欄位。",
      organization_identity: "組織國民身分證號為必填欄位。",
      registration_ad: "公司登記公告圖片為必填欄位。",
      last_published_ad: "最近一次官方公告圖片為必填欄位。",
      telephone: "市內電話為必填欄位。",
      fatherName: "父親姓名為必填欄位。",
      nationalCode: "國民身分證字號為必填欄位。",
      id: "身分證字號為必填欄位。",
      birthday: "出生日期為必填欄位。",
      placeBirthday: "出生地為必填欄位。",
      postalCode: "郵遞區號為必填欄位。",
      nationalCodePic: "國民身分證照片為必填欄位。",
      address: "完整地址為必填欄位。",
      plaque: "門牌號碼為必填欄位。",
    },
  },
  createUserForm: {
    name: "姓名",
    lastName: "姓氏",
    nid: "國民身分證字號",
    phone: "手機號碼",
    create: "建立",
    errors: {
      nameRequired: "請輸入姓名！",
      lastNameRequired: "請輸入姓氏！",
      nidRequired: "請輸入國民身分證字號！",
      phoneRequired: "請輸入手機號碼！",
    },
  },
  lastView: {
    cardTitle: "您的最近訪問紀錄",
    cardSubtitle: "您最近瀏覽過的頁面",
    tableHeaders: {
      page: "頁面",
      address: "網址",
      enterDate: "進入時間",
      leaveDate: "離開時間",
      timeSpent: "停留時間",
    },
    viewAll: "查看全部",
    timeUnit: "分鐘",
    pages: {
      home: "首頁",
      panels: "面板",
      profile: "完善個人檔案",
    },
  },
walletWidget: {
  title: "近期交易",
  balanceLabel: "您的餘額：",
  viewTransactions: "查看交易",
  transactionTypes: {
    withdraw: "提現",
    deposit: "入金",
    charge: "錢包充值",
    refund: "退款",
    default: "交易",
    adminCharge: "管理員調整",
    agency: "代理佣金",
  },
},
  panelWidget: {
    title: "您擁有 {title} 面板（{days} 天有效期）",
    renewPrompt: "點擊下方按鈕購買或續費您的面板。",
    buyPanel: "購買面板",
    percentage: "{value}%",
    infinity: "∞",
    days: "{count} 天",
  },
  component: {
    title: "您邀請的使用者",
    columns: {
      row: "序號",
      name: "姓名",
      family: "姓氏",
      username: "使用者名稱",
      phone: "手機號碼",
      created_at: "註冊日期",
      actions: "操作",
    },
    unknown: "未知",
    error: "錯誤",
    breadcrumb: "邀請的使用者",
  },
  table: {
    itemsPerPage: "每頁顯示筆數",
    pageText: "顯示第 {0} 至 {1} 筆，共 {2} 筆",
    prevText: "上一頁",
    nextText: "下一頁",
    noDataText: "暫無資料",
    search: "搜尋",
  },
  UserHistory: {
    title: "使用者歷史紀錄",
    add_history: "新增歷史紀錄",
    send_message: "發送訊息",
    close: "關閉",
    save: "儲存",
    cancel: "取消",
    new_history_dialog_title: "新增歷史紀錄",
    send_message_dialog_title: "發送訊息",
    negotiations: "已進行之洽談",
    follow_up: "下次聯繫需追蹤事項",
    success_history: "歷史紀錄新增成功。",
    success_message: "訊息發送成功。",
    columns: {
      id: "編號",
      title: "標題",
      status: "階段",
      current_time_date: "最近聯繫日期",
      current_time_hour: "最近聯繫時間",
      next_time_date: "下次聯繫日期",
      next_time_hour: "下次聯繫時間",
      user_id: "支援人員",
      actions: "操作",
    },
    table: {
      itemsPerPage: "每頁顯示筆數",
      pageText: "顯示第 {0} 至 {1} 筆，共 {2} 筆",
      prevText: "上一頁",
      nextText: "下一頁",
      noDataText: "暫無資料",
      search: "搜尋",
    },
    form: {
      title: "標題",
      status: "階段",
      current_time: "最近聯繫時間",
      description: "說明",
      next_time: "下次聯繫時間",
      pursue_text: "下次追蹤內容",
      category: "選擇分類",
      message_title: "訊息標題",
    },
  },
  newUserTransactions: {
    userWallet: "使用者錢包",
    transactionList: "交易清單",
    userTransactions: "使用者交易",
    terminal: "終端機",
    liveSms: "即時簡訊",
    realEstateNews: "Divar 最新消息",
    rial: "里亞爾",
    row: "序號",
    uniqueId: "唯一識別碼",
    amount: "金額",
    time: "時間",
    createdAt: "日期",
    description: "補充說明",
    type: "交易類型",
    product_description: "說明",
    serviceId: "服務名稱",
    balanceAfter: "交易後餘額",
    perPage: "每頁筆數",
    search: "搜尋",
    balance: "餘額",
    transactionListTooltip: "交易清單",
    panelLogin: "登入面板",
    history: "歷史紀錄",
    error: {
      terminalWallet: "取得終端機錢包時發生錯誤",
    },
    transactionType: "交易類型",
    service: "服務",
    dateFrom: "起始日期",
    dateTo: "結束日期",
    oldWallet: "舊錢包",
    depositReceipt: "入款收據",
    showReceipt: "顯示收據",
    transactionTypes: {
      online: "線上支付",
      admin: "管理員操作",
      refund: "修正交易",
      agency: "代理",
      withdraw: "提領",
      deposit: "入款",
      adminCharge: "管理員充值",
      charge: "錢包充值",
      refund: "退款",
    },
    error: {
      imageLoad: "圖片載入失敗！",
    },
  },
  buyPanel: {
    alert: {
      choosePanel: "請仔細選擇面板類型！",
    },
    dialog: {
      title: "購買面板",
      confirmPurchase: "您確定要購買 {title} 面板嗎？",
      discountCodeLabel: "折扣碼",
      discountCodePlaceholder: "請輸入您的折扣碼",
      applyDiscount: "套用折扣碼",
      purchase: "購買",
      iHaveDiscount: "我有折扣碼",
    },
    toast: {
      discountApplied: "折扣碼已成功套用！",
      purchaseSuccess: "套餐購買成功",
      error: "發生錯誤：{message}",
      unauthorized: "請先登入",
      validationError: "驗證錯誤：{message}",
    },
    currency: "里亞爾",
  },
  panelCard: {
    rial: "里亞爾",
    days: "天",
    buyPanel: "購買面板",
  },
  cons: {
    title: "選擇表情符號",
  },
  cons1: {
    title: "預設文字",
  },
  MENUS: {
    AD_TERMINAL_SYSTEM: "大型廣告終端系統",
  },
};
